const keydownHandler = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        (event.target as HTMLElement).click();
    }
};

const addEnterAndSpaceHandler = () => {
    const buttonElements = document.querySelectorAll<HTMLElement>('[role="button"], [role="menuitem"], .keyboard-interactive');

    buttonElements.forEach(element => {
        if (element.dataset.listenerAdded) return;

        const keydownHandler = (event: KeyboardEvent) => {
            if ((event.key === 'Enter' || event.key === ' ') && !event.repeat) {
                event.preventDefault();
                element.click();
            }
        };

        element.addEventListener('keydown', keydownHandler);
        element.dataset.listenerAdded = "true";
    });
};

export const removeEnterAndSpaceHandler = () => {
    const buttonElements = document.querySelectorAll('[role="button"], .keyboard-interactive');

    buttonElements.forEach(element => {
        element.removeEventListener('keydown', keydownHandler);
    });
}
/**
 *  Helper function to add anchors above main elements
 */
export const setupSkipToContent = () => {
    const mainElement = document.querySelector('main');
    const skipToContentButton = document.querySelector('#skip-to-content');

    if (!mainElement || !skipToContentButton) return;

    const anchor = Object.assign(document.createElement('div'), {
        id: "main-content-anchor",
        tabIndex: -1
    });

    // attach anchor as a sibling before <main>
    mainElement.before(anchor);

    // workaround to make sure the content gets focussed on button click
    skipToContentButton.addEventListener('click', function(){
        anchor.focus();
    });
}


export const setupSkipToSearchresult = () => {
    const skipToSearchresultButton = document.querySelector('#skip-to-results');
    const searchresultAnchor = document.querySelector('#search-results-anchor') as HTMLDivElement;

    if (!searchresultAnchor || !skipToSearchresultButton) return;

    skipToSearchresultButton.addEventListener('click', function(){
        if(searchresultAnchor){
            searchresultAnchor.focus();
            searchresultAnchor.scrollIntoView({block: "start", inline: 'start'});
        }
    });
}


export const enableKeyboardClickSupportForClass = (selector = '.keyboard-clickable') => {
    document.addEventListener("keydown", (event: KeyboardEvent) => {
        if (
            (event.key === "Enter" || event.key === " ") &&
            event.target instanceof HTMLElement &&
            event.target.matches(selector)
        ) {
            event.preventDefault();
            event.target.click();
        }
    });
};

export { addEnterAndSpaceHandler }
